import _toConsumableArray from "/home/runner/work/landing-page/landing-page/node_modules/@babel/runtime/helpers/esm/toConsumableArray.js";
import _slicedToArray from "/home/runner/work/landing-page/landing-page/node_modules/@babel/runtime/helpers/esm/slicedToArray.js";
import _asyncToGenerator from "/home/runner/work/landing-page/landing-page/node_modules/@babel/runtime/helpers/esm/asyncToGenerator.js";
import _regeneratorRuntime from "/home/runner/work/landing-page/landing-page/node_modules/@babel/runtime/regenerator/index.js";
import { useState, useEffect, useRef, useCallback } from 'react';
function fetchGhostBlogPosts(_x) {
  return _fetchGhostBlogPosts.apply(this, arguments);
}
function _fetchGhostBlogPosts() {
  _fetchGhostBlogPosts = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee2(api) {
    var _ref5,
      pinnedPostId,
      limit,
      data,
      pinnedPost,
      postLimit,
      posts,
      _args2 = arguments;
    return _regeneratorRuntime.wrap(function _callee2$(_context2) {
      while (1) switch (_context2.prev = _context2.next) {
        case 0:
          _ref5 = _args2.length > 1 && _args2[1] !== undefined ? _args2[1] : {}, pinnedPostId = _ref5.pinnedPostId, limit = _ref5.limit;
          data = [];
          if (!pinnedPostId) {
            _context2.next = 12;
            break;
          }
          _context2.prev = 3;
          _context2.next = 6;
          return api.posts.read({
            id: pinnedPostId
          }, {
            include: "authors"
          });
        case 6:
          pinnedPost = _context2.sent;
          data.push(pinnedPost);
          _context2.next = 12;
          break;
        case 10:
          _context2.prev = 10;
          _context2.t0 = _context2["catch"](3);
        case 12:
          postLimit = Number(limit) || 3;
          _context2.prev = 13;
          _context2.next = 16;
          return api.posts.browse({
            limit: postLimit,
            include: "authors"
          });
        case 16:
          posts = _context2.sent;
          data.push.apply(data, _toConsumableArray(posts));
          _context2.next = 22;
          break;
        case 20:
          _context2.prev = 20;
          _context2.t1 = _context2["catch"](13);
        case 22:
          return _context2.abrupt("return", data.slice(0, postLimit).map(mapper));
        case 23:
        case "end":
          return _context2.stop();
      }
    }, _callee2, null, [[3, 10], [13, 20]]);
  }));
  return _fetchGhostBlogPosts.apply(this, arguments);
}
function sanitize(excerpt) {
  var words = excerpt.replace(/[\n\r]+/g, " ").replace(/\s+\[(http|\/)[^\]]+]?/g, "").replace(/^\s+|\s+$/g, "").split(/\s+/).filter(Boolean).slice(0, 30);
  var last = words[words.length - 1];
  return "".concat(words.join(" ")).concat(/\.$/.test(last) ? "" : "\u2026");
}
function mapper(_ref) {
  var customExcerpt = _ref.custom_excerpt,
    excerpt = _ref.excerpt,
    id = _ref.id,
    metaDescription = _ref.meta_description,
    primary_author = _ref.primary_author,
    title = _ref.title,
    url = _ref.url;
  var _ref2 = primary_author || {},
    _ref2$name = _ref2.name,
    author = _ref2$name === void 0 ? "" : _ref2$name,
    _ref2$profile_image = _ref2.profile_image,
    userImageURL = _ref2$profile_image === void 0 ? null : _ref2$profile_image;
  return {
    id: id,
    title: title || "",
    summary: metaDescription || customExcerpt || sanitize(excerpt || ""),
    author: author,
    url: url || "https://blog.streamr.network/",
    userImageURL: userImageURL
  };
}
function useGhostBlogPosts(api) {
  var _ref3 = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {},
    pinnedPostId = _ref3.pinnedPostId,
    _ref3$limit = _ref3.limit,
    limit = _ref3$limit === void 0 ? 3 : _ref3$limit;
  var _useState = useState([]),
    _useState2 = _slicedToArray(_useState, 2),
    posts = _useState2[0],
    setPosts = _useState2[1];
  useEffect(function () {
    var mounted = true;
    function fn() {
      return _fn.apply(this, arguments);
    }
    function _fn() {
      _fn = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee() {
        var p;
        return _regeneratorRuntime.wrap(function _callee$(_context) {
          while (1) switch (_context.prev = _context.next) {
            case 0:
              _context.next = 2;
              return fetchGhostBlogPosts(api, {
                pinnedPostId: pinnedPostId,
                limit: limit
              });
            case 2:
              p = _context.sent;
              if (mounted) {
                _context.next = 5;
                break;
              }
              return _context.abrupt("return");
            case 5:
              setPosts(p);
            case 6:
            case "end":
              return _context.stop();
          }
        }, _callee);
      }));
      return _fn.apply(this, arguments);
    }
    fn();
    return function () {
      mounted = false;
    };
  }, [api, pinnedPostId, limit]);
  return posts;
}
function useGlobalKeyDownEffect(onKeyDown) {
  var onKeyDownRef = useRef(onKeyDown);
  useEffect(function () {
    onKeyDownRef.current = onKeyDown;
  }, [onKeyDown]);
  useEffect(function () {
    function onKeyDown2(e) {
      onKeyDownRef.current(e);
    }
    window.addEventListener("keydown", onKeyDown2);
    return function () {
      window.removeEventListener("keydown", onKeyDown2);
    };
  }, []);
}
function useRefs() {
  for (var _len = arguments.length, refs = new Array(_len), _key = 0; _key < _len; _key++) {
    refs[_key] = arguments[_key];
  }
  return useCallback(function (el) {
    for (var i = 0; i < refs.length; i++) {
      var ref = refs[i];
      if (!ref) {
        continue;
      }
      if (typeof ref === "function") {
        ref(el);
        continue;
      }
      ref.current = el;
    }
  }, [].concat(refs));
}
var isSSR = typeof IntersectionObserver === "undefined";
function useInViewport(ref) {
  var _useState3 = useState(null),
    _useState4 = _slicedToArray(_useState3, 2),
    target = _useState4[0],
    setTarget = _useState4[1];
  var targetRef = useRef(null);
  var _useState5 = useState(false),
    _useState6 = _slicedToArray(_useState5, 2),
    inViewport = _useState6[0],
    setInViewport = _useState6[1];
  var observerRef = useRef(isSSR ? void 0 : new IntersectionObserver(function (entries) {
    entries.forEach(function (entry) {
      if (entry.target === targetRef.current) {
        setInViewport(entry.isIntersecting);
      }
    });
  }));
  useEffect(function () {
    var observer = observerRef.current;
    targetRef.current = target;
    if (target) {
      observer === null || observer === void 0 ? void 0 : observer.observe(target);
    } else {
      setInViewport(false);
    }
    return function () {
      if (target) {
        observer === null || observer === void 0 ? void 0 : observer.unobserve(target);
      }
    };
  }, [target]);
  useEffect(function () {
    var observer = observerRef.current;
    return function () {
      observer === null || observer === void 0 ? void 0 : observer.disconnect();
    };
  }, []);
  useEffect(function () {
    if (isSSR) {
      setInViewport(true);
    }
  }, []);
  var attach = useRefs(setTarget, ref);
  return [attach, inViewport];
}
function useOnMouseDownOutsideEffect(callback, ref) {
  var _ref4 = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : {},
    isInside = _ref4.isInside;
  var _useState7 = useState(null),
    _useState8 = _slicedToArray(_useState7, 2),
    target = _useState8[0],
    setTarget = _useState8[1];
  var callbackRef = useRef(callback);
  useEffect(function () {
    callbackRef.current = callback;
  }, [callback]);
  useEffect(function () {
    if (!target) {
      return function () {};
    }
    function onInnerMouseDown(e) {
      if (e.target instanceof Element && (target !== null && target !== void 0 && target.contains(e.target) || isInside !== null && isInside !== void 0 && isInside(target, e.target))) {
        return;
      }
      callbackRef.current();
    }
    window.addEventListener("mousedown", onInnerMouseDown);
    return function () {
      window.removeEventListener("mousedown", onInnerMouseDown);
    };
  }, [target]);
  return useRefs(setTarget, ref);
}
export { useGhostBlogPosts, useGlobalKeyDownEffect, useInViewport, useOnMouseDownOutsideEffect, useRefs };